// Types the hero search examples into the placeholder, letter by letter,
// holds the sentence, deletes it and moves on to the next one. Only the
// placeholder changes; the field stays empty and usable at all times.
//
// Timings (ms)
const TYPE_MS = 45;
const DELETE_MS = 20;
const HOLD_MS = 2200;
const GAP_MS = 400;

function animatePlaceholder(input) {
  if (!input.dataset.placeholders) return;

  let sentences;
  try {
    sentences = JSON.parse(input.dataset.placeholders);
  } catch (_error) {
    return;
  }
  if (!Array.isArray(sentences) || sentences.length === 0) return;

  // The server renders the first sentence as the static placeholder, so the
  // field never looks empty before this script runs.
  input.placeholder = sentences[0];

  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  if (reduce || sentences.length < 2) return;

  let index = 0;
  let position = sentences[0].length;
  let phase = "hold";

  const stop = () => {
    if (input._placeholderTimer) {
      clearTimeout(input._placeholderTimer);
      input._placeholderTimer = null;
    }
  };

  const schedule = (fn, ms) => {
    stop();
    input._placeholderTimer = setTimeout(fn, ms);
  };

  const paused = () => input.value !== "" || document.activeElement === input;

  const step = () => {
    if (paused()) return;

    const sentence = sentences[index];

    if (phase === "hold") {
      phase = "delete";
      schedule(step, HOLD_MS);
      return;
    }

    if (phase === "delete") {
      if (position > 0) {
        position -= 1;
        input.placeholder = sentence.slice(0, position);
        schedule(step, DELETE_MS);
      } else {
        index = (index + 1) % sentences.length;
        phase = "type";
        schedule(step, GAP_MS);
      }
      return;
    }

    // phase === "type"
    const next = sentences[index];
    if (position < next.length) {
      position += 1;
      input.placeholder = next.slice(0, position);
      schedule(step, TYPE_MS);
    } else {
      phase = "hold";
      schedule(step, HOLD_MS);
    }
  };

  const resume = () => {
    if (paused()) return;
    // Show the whole sentence again so a half-typed fragment never sits
    // still while the user looks elsewhere.
    position = sentences[index].length;
    input.placeholder = sentences[index];
    phase = "hold";
    schedule(step, HOLD_MS);
  };

  input.addEventListener("focus", () => {
    stop();
    input.placeholder = sentences[index];
  });
  input.addEventListener("blur", resume);
  input.addEventListener("input", () => {
    if (input.value !== "") stop();
  });

  schedule(step, HOLD_MS);
}

function initHomeSearchPlaceholder() {
  const input = document.getElementById("home-search-input");
  if (!input || input._placeholderBound) return;
  input._placeholderBound = true;
  animatePlaceholder(input);
}

document.addEventListener("turbo:before-cache", () => {
  const input = document.getElementById("home-search-input");
  if (!input) return;
  if (input._placeholderTimer) {
    clearTimeout(input._placeholderTimer);
    input._placeholderTimer = null;
  }
});

document.addEventListener("turbo:load", initHomeSearchPlaceholder);
document.addEventListener("DOMContentLoaded", initHomeSearchPlaceholder);
